/**
 * Copyright (c) 2017 CA. All rights reserved.
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file for details.
 */


export const METRICS_DATA_REQUEST = 'METRICS_DATA_REQUEST';
export const METRICS_DATA_SUCCESS = 'METRICS_DATA_SUCCESS';
export const METRICS_DATA_ERROR = 'METRICS_DATA_ERROR';

export const METRICS_API_LIST_REQUEST = 'METRICS_API_LIST_REQUEST';
export const METRICS_API_LIST_SUCCESS = 'METRICS_API_LIST_SUCCESS';
export const METRICS_API_LIST_ERROR = 'METRICS_API_LIST_ERROR';

export const METRICS_APP_LIST_REQUEST = 'METRICS_APP_LIST_REQUEST';
export const METRICS_APP_LIST_SUCCESS = 'METRICS_APP_LIST_SUCCESS';
export const METRICS_APP_LIST_ERROR = 'METRICS_APP_LIST_ERROR';

export const METRICS_ORG_LIST_REQUEST = 'METRICS_ORG_LIST_REQUEST';
export const METRICS_ORG_LIST_SUCCESS = 'METRICS_ORG_LIST_SUCCESS';
export const METRICS_ORG_LIST_ERROR = 'METRICS_ORG_LIST_ERROR';

export const METRICS_GATEWAY_LIST_REQUEST = 'METRICS_GATEWAY_LIST_REQUEST';
export const METRICS_GATEWAY_LIST_SUCCESS = 'METRICS_GATEWAY_LIST_SUCCESS';
export const METRICS_GATEWAY_LIST_ERROR = 'METRICS_GATEWAY_LIST_SUCCESS';

export const HISTORICAL_METRIC_30DAYS = 'HISTORICAL_METRIC_30DAYS';
export const HISTORICAL_METRIC_52WEEKS = 'HISTORICAL_METRIC_52WEEKS';

export const TYPE_BY_MINUTE = 'by-minute';
export const TYPE_BY_DAY = 'by-day';
export const TYPE_BY_HOUR = 'by-hour';
export const TYPE_BY_WEEK = 'by-week';
export const TYPE_BY_MONTH = 'by-month';

export const TIME_RANGE_HOUR = 'hour';
export const TIME_RANGE_DAY = 'day';
export const TIME_RANGE_WEEK = 'week';
export const TIME_RANGE_MONTH = 'month';
export const TIME_RANGE_CUSTOM = 'custom';

export const API_BASED = 'apis';
export const ORG_BASED = 'orgs/plan';

export const AGGREGATED_DATA_TYPE = '1';

export const SET_CHART_STATE = 'SET_CHART_STATE';

export const METRICS_CUSTOM_CHART_DATA_REQUEST = 'METRICS_CUSTOM_CHART_DATA_REQUEST';
export const METRICS_CUSTOM_CHART_DATA_SUCCESS = 'METRICS_CUSTOM_CHART_DATA_SUCCESS';
export const METRICS_CUSTOM_CHART_DATA_ERROR = 'METRICS_CUSTOM_CHART_DATA_ERROR';

export const METRICS_CUSTOM_REPORT_REQUEST = 'METRICS_CUSTOM_REPORT_REQUEST';
export const METRICS_CUSTOM_REPORT_SUCCESS = 'METRICS_CUSTOM_REPORT_SUCCESS';
export const METRICS_CUSTOM_REPORT_ERROR = 'METRICS_CUSTOM_REPORT_ERROR';

export const METRICS_CUSTOM_REPORT_CREATE_REPORT_REQUEST = 'METRICS_CUSTOM_REPORT_CREATE_REPORT_REQUEST';
export const METRICS_CUSTOM_REPORT_CREATE_REPORT_SUCCESS = 'METRICS_CUSTOM_REPORT_CREATE_REPORT_SUCCESS';
export const METRICS_CUSTOM_REPORT_CREATE_REPORT_ERROR = 'METRICS_CUSTOM_REPORT_CREATE_REPORT_ERROR';

export const METRICS_CUSTOM_REPORT_CREATE_CHART_REQUEST = 'METRICS_CUSTOM_REPORT_CREATE_CHART_REQUEST';
export const METRICS_CUSTOM_REPORT_CREATE_CHART_SUCCESS = 'METRICS_CUSTOM_REPORT_CREATE_CHART_SUCCESS';
export const METRICS_CUSTOM_REPORT_CREATE_CHART_ERROR = 'METRICS_CUSTOM_REPORT_CREATE_CHART_ERROR';

export const METRICS_CUSTOM_REPORT_GET_PANELS_REQUEST = 'METRICS_CUSTOM_REPORT_GET_PANELS_REQUEST';
export const METRICS_CUSTOM_REPORT_GET_PANELS_SUCCESS = 'METRICS_CUSTOM_REPORT_GET_PANELS_SUCCESS';
export const METRICS_CUSTOM_REPORT_GET_PANELS_ERROR = 'METRICS_CUSTOM_REPORT_GET_PANELS_ERROR';

export const METRICS_CUSTOM_REPORT_EDIT_PANEL_REQUEST = 'METRICS_CUSTOM_REPORT_EDIT_PANEL_REQUEST';
export const METRICS_CUSTOM_REPORT_EDIT_PANEL_SUCCESS = 'METRICS_CUSTOM_REPORT_EDIT_PANEL_SUCCESS';
export const METRICS_CUSTOM_REPORT_EDIT_PANEL_ERROR = 'METRICS_CUSTOM_REPORT_EDIT_PANEL_ERROR';



// WEBPACK FOOTER //
// ./src/constants/metrics.js